import { useEffect } from 'react';

function DisableInspect() {
  useEffect(() => {
    const handleContextMenu = (event) => event.preventDefault();

    const handleKeyDown = (event) => {
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J')) ||
        (event.ctrlKey && event.key === 'U')
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return null; // This component does not render anything visible
}

export default DisableInspect;
